/** API client for the OpenDSS live-solve endpoint (FR-ENG-305). */

import { post } from './client.ts'
import type { OpenDSSRunResult, OpenDSSRunParams } from '../types/opendss.ts'

function buildQS(params: Record<string, string | number | boolean | undefined | null>): string {
  const qs = new URLSearchParams()
  for (const [k, v] of Object.entries(params)) {
    if (v !== undefined && v !== null) qs.set(k, String(v))
  }
  const s = qs.toString()
  return s ? `?${s}` : ''
}

/**
 * Solve the exported feeder model through the real OpenDSS engine and return
 * the results live. No request body — all knobs are query params.
 */
export function runOpenDSS(
  feederId: number,
  params?: OpenDSSRunParams,
): Promise<OpenDSSRunResult> {
  return post<OpenDSSRunResult>(
    `/opendss/run/feeders/${feederId}${buildQS({
      avg_demand_kw: params?.avg_demand_kw,
      power_factor: params?.power_factor,
      include_capacitors: params?.include_capacitors,
    })}`,
  )
}
